const BACKEND_DEVICE = '/certificates';

export const ROUTE_HOME_CERTIFICATES = BACKEND_DEVICE + '/home';

export const certificatesRoutes = [ROUTE_HOME_CERTIFICATES];
